import { captureMessage, type SeverityLevel } from '@sentry/react';

export const SentryCaptureMessage = (
  message: string,
  level: SeverityLevel = 'error'
) => {
  captureMessage(message, level);
};
